import React from "react";
import { Layout } from "antd";

const { Header, Content } = Layout;
import styles from "@/ui/page.module.css";
import AppHeader from "./AppHeader";
import EventBanner from "../events/EventBanner";

interface LayoutProps {
    title?: string;
    children: React.ReactNode;
    headerContent?: React.ReactNode;
    /** Pages with their own event overview (home) hide the event banner. */
    showEventBanner?: boolean;
}

const headerStyle: React.CSSProperties = {
    height: 50,
    background: "#7cbbf5",
    textAlign: "center",
    color: "#fff",
    lineHeight: "50px",
    display: "flex",
    alignItems: "center",
    padding: "0px 10px",
};

export default function AppLayout({
    title,
    children,
    headerContent,
    showEventBanner = true,
}: LayoutProps) {
    return (
        <Layout className={styles.app}>
            <Header className={styles.header} style={headerStyle}>
                <AppHeader title={title} headerContent={headerContent} />
            </Header>
            {showEventBanner && <EventBanner />}

            <Content className={styles.pageContainer}>{children}</Content>
        </Layout>
    );
}
